export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    linkUrl: String,
    text: String,
    title: String
  },
  data: function data() {
    return {
      canContinue: false
    };
  },
  methods: {
    continuePayment: function continuePayment() {
      var _this = this;
      this.$emit("continue", function () {
        return _this.$emit("input", false);
      });
    },
    copyLink: function copyLink() {
      navigator.clipboard.writeText(this.linkUrl);
    },
    handleShown: function handleShown() {
      this.$emit("input", false);
    }
  }
};